import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, TemplateRef, ElementRef, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DialogAction, DialogCloseResult, DialogRef, DialogResult, DialogService } from '@progress/kendo-angular-dialog';
import { RecurrenceEditorComponent } from '@progress/kendo-angular-scheduler'
import { map, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { ApiService } from '../services/api.service';

@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScheduleComponent implements OnInit, OnDestroy {


  public form: UntypedFormGroup;

  @ViewChild('templateForm', {static: true}) 
  formControl: TemplateRef<HTMLDivElement>;

  @Input()
  public rules$: Observable<any[]>;
  // public subscription = new Subscription();
  public steps = { minute: 60 };
  private destroy$ = new Subject<void>(); // Destroy notifier
  public startTimeUTC$: Observable<string>;

  public days = [
    { text: "Sun", value: 0 },
    { text: "Mon", value: 1 },
    { text: "Tue", value: 2 },
    { text: "Wed", value: 3 },
    { text: "Thu", value: 4 },
    { text: "Fri", value: 5 },
    { text: "Sat", value: 6 },
  ];

  constructor(
    private formBuilder: UntypedFormBuilder, 
    private dialogService: DialogService,
    private apiService: ApiService) { 

    this.form = this.formBuilder.group({

      startTime: new UntypedFormControl(null, Validators.required),
      startTimezone: new UntypedFormControl(),
      title: new UntypedFormControl(""),
      description: new UntypedFormControl(""),

      type: new UntypedFormControl(""),
      repeat: new UntypedFormControl(),
      on: new UntypedFormControl(),
      email: new UntypedFormControl(""),
      enabled: new UntypedFormControl(true)
    });
    
    this.startTimeUTC$ = this.form.get('startTime')?.valueChanges.pipe(
      map(value => {
        if (value instanceof Date) {
          const hours = value.getUTCHours().toString().padStart(2, '0');
          const minutes = value.getUTCMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes} GMT`;
        } else {
          return null;
        }
      })
    );
  
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    // this.subscription.unsubscribe();
  }

  ngOnInit(): void {
  }

    
  onSelectionChange(event: any): void {
    console.log('Selected indexes:', event);
  }

  addRule(event) {
    const startDate = null;

    this.form.setValue(
      {
        startTime: startDate,
        type: null,
        repeat: 'Daily',
        on: [],
        startTimezone: 'UTC',
        title: null,
        description: null,
        email: null,
        enabled: true
      } 
    );

    const dialog: DialogRef = this.dialogService.open({
      title: 'Add Rule',
      content: this.formControl,
      actions: [
          { text: 'Save', primary: true },
          { text: 'Cancel' }
      ],
      width: 508,
      height: 470,
      minWidth: 400,

    });

    dialog.result.pipe(
      map((result:any)=>{

        if (result.text == 'Save') {
          const r = this.form.value;

          const frequency = {
            on: (r.on || []).map((v)=>v.value),
            repeat: r.repeat
          }
          const properties = {
            email: r.email
          };
          const disabled = !r.enabled;

          let startTime = null;
          if (r.startTime) {
            let m1 = /T(.*)/g.exec(r.startTime.toISOString());
            if (m1) {
              startTime = m1[1]
            }  
          }

          const g = ('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          }));
          
          this.apiService.mutateRule(g, r.webhook, JSON.stringify(frequency), startTime, r.type, JSON.stringify(properties), disabled, false, ()=>{});

          console.log(r.startTime);
        }

      }),
      takeUntil(this.destroy$)
    ).subscribe();

  }

  deleteRule(rule: any) {
    this.apiService.mutateRule(rule.RowKey, rule.webhook, rule.frequency, rule.startTime, rule.type, rule.properties, rule.disabled, true, ()=>{});
  }

  editRule(rule: any) {

    const { type, disabled } = rule;
    let { startTime } = rule;
    const { repeat, on } = JSON.parse(rule.frequency || '{}');
    const { email } = JSON.parse(rule.properties || '{}');
    let startDate;

    const m = /T(.*)/g.exec(startTime);
    if (m) {
      startTime = m[1]
    }

    startDate = new Date(`${(new Date().toISOString().split("T")[0])}T${startTime}`);

    if (isNaN(startDate.getTime())) {
      startDate = null;
    }

    this.form.setValue(
      {
        startTime: startDate,
        type,
        repeat,
        on: (on || []).map((i)=>{return this.days.find((v)=>v.value == i); }),
        startTimezone: 'UTC',
        title: null,
        description: null,
        email: (email || ''),
        enabled: !disabled
      } 
    );

    const dialog: DialogRef = this.dialogService.open({
      title: 'Edit Rule',
      content: this.formControl,
      actions: [
          { text: 'Save', primary: true },
          { text: 'Cancel' }
      ],
      width: 508,
      height: 470,
      minWidth: 400,

    });

    dialog.result.pipe(
      map((result:any)=>{

        if (result.text == 'Save') {
          const r = this.form.value;

          const frequency = {
            on: (r.on || []).map((v)=>v.value),
            repeat: r.repeat
          }
          const properties = {
            email: r.email
          }
          const disabled = !r.enabled;

          startTime = null;
          if (r.startTime) {
            let m1 = /T(.*)/g.exec(r.startTime.toISOString());
            if (m1) {
              startTime = m1[1]
            }  
          }

          const m = r.startTime ? /T(.*)/g.exec(r.startTime.toISOString()): null;

          this.apiService.mutateRule(rule.RowKey, r.webhook, JSON.stringify(frequency), startTime, r.type, JSON.stringify(properties), disabled, false, ()=>{});

          console.log(r.startTime);
        }

      }),
      takeUntil(this.destroy$)
    ).subscribe();

    // show form

  }

  parseFrequency(frequency) {
    if (frequency) {
      return JSON.parse(frequency);
    }
    else {
      return null;
    }
  }

  public getRuleTitle(rule: any): string {
    const type = `${rule?.type || ''}`.toLowerCase();
    if (type.includes('summary')) {
      return 'DLP Compliance';
    }
    if (type.includes('run')) {
      return 'Failure Alert';
    }
    return rule?.type || 'Monitoring Rule';
  }

  public getRuleFrequencyLabel(rule: any): string {
    return this.parseFrequency(rule?.frequency)?.repeat || 'Daily';
  }

  public getRuleStatusLabel(rule: any): string {
    return rule?.disabled ? 'Disabled' : 'Active';
  }

  public getRuleLastRanLabel(rule: any): string {
    const value = rule?.LastRan || rule?.lastRan || rule?.Timestamp;
    return value ? new Date(value).toLocaleString() : 'Not yet run';
  }

}
